const BASE_URL = process.env.VUE_APP_API_URL;
const URL = `${BASE_URL}${process.env.VUE_APP_API_PATH}`;
const URL_IMAGE = `${BASE_URL}`;

export { URL, URL_IMAGE, BASE_URL };
